import type { SalaryEntry } from './api/types'

export type FillItem = { employeeId: string; gross: number; taxes: number }

// Prefill items for the accrual tab: only empty current-month rows (no current
// entry, zero gross/taxes, not edited) that have a previous-month accrual.
export function computeFillFromPrev(args: {
  employeeIds: string[]
  rows: Map<string, { gross: number; taxes: number }>
  hasCurrentEntry: (employeeId: string) => boolean
  isDirty: (employeeId: string) => boolean
  prevByEmployee: Map<string, SalaryEntry>
}): FillItem[] {
  const { employeeIds, rows, hasCurrentEntry, isDirty, prevByEmployee } = args
  const items: FillItem[] = []
  for (const id of employeeIds) {
    const row = rows.get(id)
    const empty =
      !hasCurrentEntry(id) && (row?.gross ?? 0) === 0 && (row?.taxes ?? 0) === 0 && !isDirty(id)
    if (!empty) continue
    const prev = prevByEmployee.get(id)
    if (!prev) continue
    items.push({ employeeId: id, gross: prev.gross, taxes: prev.taxes })
  }
  return items
}
